import { render, staticRenderFns } from "./IncidencesTab.vue?vue&type=template&id=4c53592d&scoped=true&"
import script from "./IncidencesTab.vue?vue&type=script&lang=js&"
export * from "./IncidencesTab.vue?vue&type=script&lang=js&"
import style0 from "./IncidencesTab.vue?vue&type=style&index=0&id=4c53592d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c53592d",
  null
  
)

export default component.exports